/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sale_ItemsInputs */

const en_sale_items = /** @type {(inputs: Sale_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sale Items`)
};

const es_sale_items = /** @type {(inputs: Sale_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artículos en Oferta`)
};

const fr_sale_items = /** @type {(inputs: Sale_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articles en promotion`)
};

const de_sale_items = /** @type {(inputs: Sale_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sale-Artikel`)
};

const id_sale_items = /** @type {(inputs: Sale_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barang Diskon`)
};

/** @type {(inputs: Sale_ItemsInputs) => LocalizedString} */
const ja_sale_items = en_sale_items;

/** @type {(inputs: Sale_ItemsInputs) => LocalizedString} */
const zh_sale_items = en_sale_items;

/** @type {(inputs: Sale_ItemsInputs) => LocalizedString} */
const ar_sale_items = en_sale_items;

/** @type {(inputs: Sale_ItemsInputs) => LocalizedString} */
const it_sale_items = en_sale_items;

/** @type {(inputs: Sale_ItemsInputs) => LocalizedString} */
const ru_sale_items = en_sale_items;

/** @type {(inputs: Sale_ItemsInputs) => LocalizedString} */
const pt_sale_items = en_sale_items;

/** @type {(inputs: Sale_ItemsInputs) => LocalizedString} */
const ko_sale_items = en_sale_items;

/**
* | output |
* | --- |
* | "Sale Items" |
*
* @param {Sale_ItemsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sale_items = /** @type {((inputs?: Sale_ItemsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sale_ItemsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sale_items(inputs)
	if (locale === "es") return es_sale_items(inputs)
	if (locale === "fr") return fr_sale_items(inputs)
	if (locale === "de") return de_sale_items(inputs)
	if (locale === "ja") return ja_sale_items(inputs)
	if (locale === "zh") return zh_sale_items(inputs)
	if (locale === "ar") return ar_sale_items(inputs)
	if (locale === "id") return id_sale_items(inputs)
	if (locale === "it") return it_sale_items(inputs)
	if (locale === "ru") return ru_sale_items(inputs)
	if (locale === "pt") return pt_sale_items(inputs)
	return ko_sale_items(inputs)
});